import { object, array } from 'yup';

const setProjectsSchema = object().shape({
  projects: array().min(1).required('Projects is required!'),
});

export default setProjectsSchema;
